import { render } from "./myMenu.vue?vue&type=template&id=71f6130d"
import script from "./myMenu.vue?vue&type=script&lang=js"
export * from "./myMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__